import { differenceInHours, differenceInMinutes } from 'date-fns';
import { TFunction } from 'i18next';

export const getCardDate = (date: Date, t: TFunction) => {
  const now = new Date();
  const hoursDifference = differenceInHours(now, date, {
    roundingMethod: 'round',
  });

  if (hoursDifference < 24) {
    if (hoursDifference < 1) {
      const minutesDifference = differenceInMinutes(now, date, {
        roundingMethod: 'round',
      });

      if (minutesDifference < 1) {
        return t('whatsNew:justNow');
      }

      return t('whatsNew:minsAgo', { count: minutesDifference });
    }

    return t('whatsNew:hoursAgo', { count: hoursDifference });
  }

  return new Intl.DateTimeFormat(navigator.language, {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
};
